import { gql } from "@apollo/client";

export const SEASON_MANAGEMENT_STATUS_QUERY = gql`
    query SeasonManagementStatus {
        seasonManagementStatus {
            hasActiveSeason
            currentSeason {
                id
                name
                startDate
                endDate
                infoEndDate
                tagsFinalized
                isActive
            }
            topStats {
                topCheckins {
                    playerId
                    playerName
                    value
                    position
                }
                topRaidCheckins {
                    playerId
                    playerName
                    value
                    position
                }
                topWatchTime {
                    playerId
                    playerName
                    value
                    position
                }
            }
            clanMvps {
                clanId
                clanName
                clanTag
                clanColor
                playerId
                playerName
                totalVp
            }
        }
    }
`;
